<template>
    <div class="card mb-3" v-if="personnel.length > 0">
        <div class="card-header">
            <strong>Personnel</strong>
        </div>
        <div class="card-body">
            <div v-for="(field, i) in personnel">
                <div class="form-group row">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors['personnel.'+field.id+'.employee_id']}">
                        {{ field.field_label }}: <i class="fa fa-asterisk text-danger" v-if="field.is_required"></i>
                    </label>
                    <div class="col-xl-6 col-sm-8">
                        <employee-select
                            :selectedValues="field.employee_id && field.is_other !== 1 ? getEmployee(field) : {}"
                            @vselected="setEmployee($event, field.id)"
                            :hasError="errors['personnel.'+field.id+'.employee_id'] ? true : false"
                            :disabled="field.is_other === 1"
                            :filters="{is_active: 1}" />

                        <div v-if="errors['personnel.'+field.id+'.employee_id']" class="text-danger">
                            <span v-for="error in errors['personnel.'+field.id+'.employee_id']">{{ error }}</span>
                        </div>

                        <div v-if="errors['personnel.'+field.id]" class="text-danger">
                            <span v-for="error in errors['personnel.'+field.id]">{{ error }}</span>
                        </div>
                    </div>
                </div>
                <div class="form-group row" v-if="field.is_allow_other === 1">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                        Is Other {{ field.field_label }}:
                    </label>
                    <div class="col-xl-6 col-sm-8">
                        <b-form-checkbox v-model="field.is_other" :value="1" :unchecked-value="0" plain style="padding-top: 8px;" @change="resetOther(field)">Other {{ field.field_label }}</b-form-checkbox>
                    </div>
                </div>
                <div class="form-group row" v-if="field.is_allow_other === 1 && field.is_other === 1">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right" :class="{'text-danger': errors['personnel.'+field.id+'.other_personnel_name']}">
                        Other {{ field.field_label }} Name: <i class="fa fa-asterisk text-danger"></i>
                    </label>
                    <div class="col-xl-6 col-sm-8">
                        <b-form-input v-model="field.other_personnel_name" :placeholder="`Enter Other ${field.field_label} Name`" :class="{'is-invalid': errors['personnel.'+field.id+'.other_personnel_name']}" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            initialPersonnel: {
                type: Array,
                default: null,
            },
        },
        data() {
            return {
                personnel: [],
                errors: {},
            }
        },

        watch: {
            // personnel(newVal, oldVal){
            //     //Emit it
            //     this.$emit('personnelChanged', this.personnel);
            // }
        },

        computed: {


        },

        methods: {
            getEmployee(field){
                //Send it
                return {
                    EmployeeId: field.employee_id,
                    FirstName: field.employee_first_name,
                    LastName: field.employee_last_name,
                    EmployeeNumber: field.EmployeeNumber,
                };
            },

            setEmployee(payload, id){
                //Process the Fields
                for (var i = 0; i < this.personnel.length; i++)
                {
                    //Check it
                    if(this.personnel[i].id !== id)
                    {
                        continue;
                    }

                    //Set it
                    //Check for null
                    if(payload === null)
                    {
                        this.personnel[i].employee_id = null;
                    }
                    else
                    {
                        this.personnel[i].employee_id = payload.EmployeeId;
                        this.personnel[i].employee_first_name = payload.FirstName;
                        this.personnel[i].employee_last_name = payload.LastName;
                        this.personnel[i].EmployeeNumber = payload.EmployeeNumber;
                    }
                }
            },

            getPersonnel(){
                return this.personnel;
            },

            setPersonnel(personnel){
                //SEt it
                this.personnel = personnel;
            },

            setErrors(errors){
                this.errors = errors;
            },

            resetOther(field){
                //Set it
                if(field.is_other == 0)
                {
                    field.other_personnel_name = null;
                }
                else
                {
                    field.employee_id = null;
                }
            }
        },

        mounted(){
            //Set the personnel that was passed it?
            if(this.initialPersonnel)
            {
                this.personnel = this.initialPersonnel;
            }
        }
    }
</script>

<style type="text/css" scoped>
    #new-personnel {
        padding: 5px 8px;
        border: 1px dashed #ccc;
    }

    #new-personnel:hover {
        cursor: pointer;
    }
</style>
